import React, { useEffect, useState, useMemo } from 'react';
import AvatarViewer from './AvatarViewer';
import SkillTree from './SkillTree';
import StatsPanel from './StatsPanel';
import '../components/ProfilePage.css';

import { getSkills } from '../skillTree';
import { getProjects } from '../projectShowcase';

const ProfilePage = () => {
  const [skills, setSkills] = useState([]);
  const [projects, setProjects] = useState([]);
  const [stats, setStats] = useState({});
  const [activeTab, setActiveTab] = useState('Projects');

  const eventBus = useMemo(() => ({
    on: () => {},
    emit: () => {},
  }), []);

  useEffect(() => {
    const loadedSkills = getSkills();
    setSkills(loadedSkills);
    setProjects(getProjects());
    recalculateStats(loadedSkills);
  }, []);

  const handleUnlockSkill = (skillId) => {
    setSkills(prevSkills => {
      const updated = prevSkills.map(skill =>
        skill.id === skillId ? { ...skill, unlocked: true } : skill
      );
      recalculateStats(updated);
      return updated;
    });
  };

  const recalculateStats = (skillsList) => {
    const baseStats = { HP: 100, MP: 50, DPS: 10, CritChance: '5%' };
    skillsList.forEach(skill => {
      if (skill.unlocked) {
        baseStats.DPS += 2;
      }
    });
    setStats(baseStats);
  };

  return (
    <div className="profile-container diablo-theme">
      <div className="top-tabs">
        <div className="tab active">CHARACTER</div>
        <div className="tab">SKILLS</div>
        <div className="tab">TALENTS</div>
      </div>

      <div className="main-content">
        <div className="left-panel">
          <div className="character-portrait">
            <div id="avatar-canvas" className="avatar-canvas"></div>
            <AvatarViewer eventBus={eventBus} />
            <div className="item-slots-grid">
              {Array.from({ length: 10 }).map((_, idx) => (
                <div key={idx} className="item-slot"></div>
              ))}
            </div>
          </div>
        </div>

        <div className="right-panel">
          <div className="level-banner">
            <span>40</span>
            <div>LEVEL</div>
          </div>
          <div className="stats-list">
            <div className="stat"><span>Attack</span><span>16,115</span></div>
            <div className="stat"><span>Defense</span><span>16,911</span></div>
            <div className="stat"><span>Life</span><span>2,785</span></div>
            <div className="stat"><span>Angelic</span><span>98</span></div>
            <div className="stat"><span>Demonic</span><span>18</span></div>
            <div className="stat"><span>Ancestral</span><span>18</span></div>
          </div>
          <div className="gold-count">
            <span>28,514</span>
          </div>
        </div>
      </div>

      <div className="bottom-inventory">
        <div className="inventory-tabs">
          {['Projects', 'Consumables', 'Quest', 'Materials'].map(tab => (
            <div
              key={tab}
              className={`inv-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </div>
          ))}
        </div>
        <div className="inventory-grid">
          {activeTab === 'Projects' && (
            <>
              <a href="https://github.com/user/repo1" target="_blank" rel="noopener noreferrer" className="inventory-slot">
                <img src="https://placehold.co/50x50?text=Repo1" alt="Repo1" />
              </a>
              <a href="https://github.com/user/repo2" target="_blank" rel="noopener noreferrer" className="inventory-slot">
                <img src="https://placehold.co/50x50?text=Repo2" alt="Repo2" />
              </a>
              <a href="https://github.com/user/repo3" target="_blank" rel="noopener noreferrer" className="inventory-slot">
                <img src="https://placehold.co/50x50?text=Repo3" alt="Repo3" />
              </a>
            </>
          )}

          {activeTab === 'Consumables' && (
            <>
              <a href="#" className="inventory-slot"><img src="https://placehold.co/50x50?text=Coffee" alt="Coffee" /></a>
              <a href="#" className="inventory-slot"><img src="https://placehold.co/50x50?text=Water" alt="Water" /></a>
              <a href="#" className="inventory-slot"><img src="https://placehold.co/50x50?text=Pizza" alt="Pizza" /></a>
              <a href="#" className="inventory-slot"><img src="https://placehold.co/50x50?text=Steak" alt="Steak" /></a>
            </>
          )}

          {activeTab === 'Materials' && (
            <>
              <a href="https://amazon.com" className="inventory-slot"><img src="https://placehold.co/50x50?text=Laptop" alt="Laptop" /></a>
              <a href="https://amazon.com" className="inventory-slot"><img src="https://placehold.co/50x50?text=Mic" alt="Mic" /></a>
              <a href="https://amazon.com" className="inventory-slot"><img src="https://placehold.co/50x50?text=Camera" alt="Camera" /></a>
              <a href="https://amazon.com" className="inventory-slot"><img src="https://placehold.co/50x50?text=Dumbbells" alt="Dumbbells" /></a>
            </>
          )}

          {activeTab === 'Quest' && (
            <p style={{ color: '#888', gridColumn: '1 / -1', textAlign: 'center' }}>Quest items coming soon.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;